import './banks.scss';

if ($(".swiper-banks").length) {
  new window.Swiper('.swiper-banks', { // eslint-disable-line
    slidesPerView: 6,
    // spaceBetween: 10,
    speed: 600,
    loop: true,
    autoplay: {
      delay: 3500,
    },
    navigation: {
      prevEl: '.banks-carousel__button--prev',
      nextEl: '.banks-carousel__button--next',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 2,
        autoplay: {
          delay: 3000,
        },
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
    },
  });
}
